/********************************************************************
 * Project: KENSHIN（2021）
 * Class: Common service
 * ----------------------------------------
 * <summary>
 * Common service
 * </summary>
 * <history>
 *      CuongDL     2021/09/17     Create
 * </history>
 ********************************************************************/
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EndpointsConfig } from '../config/endpoints.config';
@Injectable({
  providedIn: 'root'
})

export class CommonService {

  constructor(private http: HttpClient) { }

  CheckConcurrentInfo(pConcurent: any) {
    return this.http.post<any>(EndpointsConfig.concurrent.checkConcurent, pConcurent);
  }
  AddConcurentInfo(pConcurent: any){
    return this.http.post<any>(EndpointsConfig.concurrent.addConcurent, pConcurent);
  }
  DeleteConcurent(pConcurent: any){
    return this.http.post<any>(EndpointsConfig.concurrent.deleteConcurent, pConcurent);
  }
  GetTaxInfo(pRsvDate: any){
    return this.http.post<any>(EndpointsConfig.common.taxinfo, pRsvDate);
  }
  SearchAddress(pStrPostCode: any) {
    return this.http.post<any>(EndpointsConfig.common.searchAddress, {PostCode: pStrPostCode});
  }
}
